const token = {
  namespaced: true,
  state: {
    token: {},
  },
  mutations: {
    login: (state, params) => {
      state.token = params
    },
    logout: (state) => {
      state.token = null
    },
  },
  getters: {
    isLogin: (state) => {
      return Boolean(state.token.accessToken)
    },
    getToken: (state) => {
      return state.token
    },
  },
  actions: {
    login: ({ commit }, params) => {
      commit('login', params)
    },
  },
}

export default token
